

export function uploadUrl(url) {
  if (url == "") return "";

  var imgurl = process.env.imgUrl;

  return imgurl + "/" + url;
}


export function getInfoByUrl (url){
  var urlinfo = {};
  var search = url.split("?");
  if(search.length>1){
      var searchpara = search.pop();
      var paras = searchpara.split("&");
      var urlParas=[];
      for(var i=0,l=paras.length;i<l; i++){
          var item=paras[i].split("=");
          if(item.length>1){
              urlParas.push({
                  Key:item[0],
                  Value:decodeURI(item[1])
              })
              urlinfo[item[0]]=decodeURI(item[1]);
          }

      }
  }
  return urlinfo;
}

export function date(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if (time == 0) return '-';

  if ((time + "").length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  var date = new Date();
  if (typeof time === "object") {
    date = time;
  } else {
    date = new Date(parseInt(time + ""));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }

  var time_str = format.replace(
    /{(y|m|d|h|i|s|a)+}/g,
    function(result, key) {
      var value = formatObj[key];
      if (key === "a")
        return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
      if (result.length > 0 && value < 10) {
        value = "0" + value;
      }
      return value || 0;
    }
    // (result, key) => {

    // }
  );
  return time_str;
}


// export function format (date, format) {
//   if (!date) {
//     return ''
//   }

//   let d = new Date(date)

//   // 年
//   if (/YYYY/.test(format)) {
//     format = format.replace(/YYYY/, d.getFullYear())
//   }
//   // 月份
//   let month = d.getMonth() + 1
//   if (/MM/.test(format)) {
//     let monthStr = month < 10 ? '0' + month : month
//     format = format.replace(/MM/, monthStr)
//   } else if (/M/.test(format)) {
//     format = format.replace(/M/, month)
//   }
//   // 日期
//   let dates = d.getDate()
//   if (/DD/.test(format)) {
//     let dateStr = dates < 10 ? '0' + dates : dates
//     format = format.replace(/DD/, dateStr)
//   } else if (/D/.test(format)) {
//     format = format.replace(/D/, dates)
//   }
//   // 小时
//   let hours = d.getHours()
//   if (/HH/.test(format)) {
//     let hoursStr = hours < 10 ? '0' + hours : hours
//     format = format.replace(/HH/, hoursStr)
//   } else if (/H/.test(format)) {
//     format = format.replace(/H/, hours)
//   } else if (/hh/.test(format)) {
//     let hoursMin = hours > 12 ? hours - 12 : hours
//     let hoursStr = hoursMin < 10 ? '0' + hoursMin : hoursMin
//     format = format.replace(/hh/, hoursStr)
//   } else if (/h/.test(format)) {
//     let hoursMin = hours > 12 ? hours - 12 : hours
//     format = format.replace(/h/, hoursMin)
//   }
//   // 分
//   let minutes = d.getMinutes()
//   if (/mm/.test(format)) {
//     let minutesStr = minutes < 10 ? '0' + minutes : minutes
//     format = format.replace(/mm/, minutesStr)
//   } else if (/m/.test(format)) {
//     format = format.replace(/m/, minutes)
//   }
//   // 秒
//   let seconds = d.getSeconds()
//   if (/ss/.test(format)) {
//     let secondsStr = seconds < 10 ? '0' + seconds : seconds
//     format = format.replace(/ss/, secondsStr)
//   } else if (/s/.test(format)) {
//     format = format.replace(/s/, seconds)
//   }
//   return format
// }


var filters = { uploadUrl: uploadUrl, getInfoByUrl: getInfoByUrl, date: date }



export default filters




// WEBPACK FOOTER //
// ./src/assets/globle.js